<template>
  <div>
      <div class="">
        <img src="../../assets/images/back.png" @click="$router.back(-1)" alt="" style="float:left;width:25px;margin:10px 0 0 0;cursor:pointer;">
      </div>
      <div class="">
        <div style="margin-top: 15px;text-align:center;">
          <el-input style="width:400px;" placeholder="请输入TxHash" v-model="input5" class="input-with-select">
            <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <!-- 服务器概览、运行情况展示 -->
        <div class="title-content clearfix">
          <!-- <div class="title-content-a clearfix title-content-a2" style="background:#FFF;width:29%;min-height:800px;">
            <div class="title-content-a-view" style="width:100%;">
              <p class="ycsj_p">运行情况概览</p>
              <div id="zhuxingpaint">
                <div class="containerA">
                    <ul class="time-vertical">
                      <li v-if="sendNode[0] != undefined"><i class="i_style">●</i><a href="javascript:void(0)">发起节点：{{sendNode[0]}}</a><b class="set_style"></b><span></span></li>
                      <li v-for="item in sendNode2"><a class="a_style" href="javascript:void(0)"></a>{{item}}<b class="set_style"></b><span></span></li>
                      <li v-if="provNode[0] != undefined"><i class="i_style2">●</i><a href="javascript:void(0)">验证节点：{{provNode[0]}}</a><b class="set_style2"></b><span></span></li>
                      <li v-for="item in provNode2"><a class="a_style" href="javascript:void(0)"></a>{{item}}<b class="set_style2"></b><span></span></li>
                      <li v-if="packList[0] != undefined"><i class="i_style3">●</i><a href="javascript:void(0)">打包节点：{{packList[0]}}</a><b class="set_style3"></b><span></span></li>
                      <li v-for="item in packList2"><a class="a_style" href="javascript:void(0)"></a>{{item}}<b class="set_style3"></b><span></span></li>
                    </ul>
                </div>
              </div>
            </div>
          </div> -->
          <div class="title-content-a title-content-ab title-content-a2">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>交易详情</span>
              </div>
              <div class="text item">
                <ul id="text-boclk">
                  <li><span>BockID:</span>{{nodeThing.blockid}}</li>
                  <li><span>BockHeight:</span>{{nodeThing.blockHeight}}</li>
                  <li><span>ZoneID:</span>{{nodeThing.zoneID}}</li>
                  <li><span>TransactionHash:</span>{{nodeThing.transaction}}</li>
                  <!-- <li class="clearfix" style="width:100%;">
                    <div style="float:left;width:150px;color:#666;">PretransationID:</div>
                    <div style="float:left;">
                      <p v-for="item in nodeThing.pretransactionId">{{item[0]}}</p>
                    </div>
                  </li> -->
                </ul>
                <hr>
                <div class="">
                  <h3 style="padding:18px 0;font-size:16px;">TXOUT列表:</h3>
                  <div class="">
                    <span @click="dialogTag(index)" class="TxOutRespond" v-for="(item,index) in nodeThing.vTxOut">{{index+1}}.TxOutRespond</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <el-dialog title="TxOutRespond信息" :visible.sync="dialogTableVisible">
          <div class="" >
            <p style="margin:8px 0;"><span class="span1">body：</span><span class="span2">{{payLoad.body}}</span></p>
            <p style="margin:8px 0;"><span class="span1">bodyType：</span><span class="span2">{{payLoad_type.bodyType}}</span></p>
            <p style="margin:8px 0;"><span class="span1">classID：</span><span class="span2">{{payLoad_type.classID}}</span></p>
            <p style="margin:8px 0;"><span class="span1">unPackClassName：</span><span class="span2">{{payLoad.unPackClassName}}</span></p>
            <p style="margin:8px 0;"><span class="span1">userAction：</span><span class="span2">{{payLoad_userData.userAction}}</span></p>
            <p style="margin:8px 0;"><span class="span1">userBody：</span><span class="span2">{{payLoad_userData.userBody}}</span></p>
            <p style="margin:8px 0;"><span class="span1">userRule：</span><span class="span2">{{payLoad_userData.userRule}}</span></p>
            <p style="margin:8px 0;"><span class="span1">userUnPackClassName：</span><span class="span2">{{payLoad_userData.userUnPackClassName}}</span></p>
            <p style="margin:8px 0;"><span class="span1">actionName：</span><span class="span2">{{payLoad_version.actionName}}</span></p>
            <p style="margin:8px 0;"><span class="span1">dataName：</span><span class="span2">{{payLoad_version.dataName}}</span></p>
            <p style="margin:8px 0;"><span class="span1">moduleName：</span><span class="span2">{{payLoad_version.moduleName}}</span></p>
            <p style="margin:8px 0;"><span class="span1">traceID：</span><span class="span2">{{payLoad_version.traceID}}</span></p>
          </div>

          vPubAddr：<span v-for="item in vPubAddr">{{item}}</span>
        </el-dialog>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name:'chainprocess',
  data(){
    return{
      pretransactionId:[],
      data:[],
      dialogTableVisible:false,
      nodeThing:'',
      transaction:this.$route.query.transaction,
      payLoad:[],
      vPubAddr:[],
      sendNode:[],
      sendNode2:[],
      provNode:[],
      provNode2:[],
      packList:[],
      packList2:[],
      input5:'',
      payLoad_type:'',
      payLoad_userData:'',
      payLoad_version:'',
    }
  },
  mounted(){
    this.getNode();
  },
  methods: {
    search(){
      let params = {
          tranHash:this.input5,
      }
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
        method:'post',
        url:window.API_HOST+'/chain/findTransactionInfo',
        data:params,
      }).then((res)=>{
        console.log(res.data.sendNode[0])
        this.nodeThing = res.data;
          console.log(this.sendNode2)
        if(res.data.sendNode.length > 1){
          for(let i=1;i<res.data.sendNode.length;i++){
            this.sendNode2.push(res.data.sendNode[i]);
          }
        }
        if(res.data.provNode.length > 1){
          for(let i=1;i<res.data.provNode.length;i++){
            this.provNode2.push(res.data.provNode[i]);
          }
        }
        if(res.data.packList.length > 1){
          for(let i=1;i<res.data.packList.length;i++){
            this.packList2.push(res.data.packList[i]);
          }
        }
        this.sendNode = res.data.sendNode;
        this.provNode = res.data.provNode;
        this.packList = res.data.packList;
      })
    },
    getNode(){
      let params = {
          tranHash:this.transaction,
      }
      params = this.$qs.stringify(params,{ indices: false });
      this.axios({
        method:'post',
        url:window.API_HOST+'/chain/findTransactionInfo',
        data:params,
      }).then((res)=>{
        console.log(res.data.sendNode[0])
        this.nodeThing = res.data;
          console.log(this.sendNode2)
        if(res.data.sendNode.length > 1){
          for(let i=1;i<res.data.sendNode.length;i++){
            this.sendNode2.push(res.data.sendNode[i]);
          }
        }
        if(res.data.provNode.length > 1){
          for(let i=1;i<res.data.provNode.length;i++){
            this.provNode2.push(res.data.provNode[i]);
          }
        }
        if(res.data.packList.length > 1){
          for(let i=1;i<res.data.packList.length;i++){
            this.packList2.push(res.data.packList[i]);
          }
        }
        this.sendNode = res.data.sendNode;
        this.provNode = res.data.provNode;
        this.packList = res.data.packList;
      })
    },
    dialogTag(index){
      this.vPubAddr = this.nodeThing.vTxOut[index].vPubAddr;
      this.payLoad = this.nodeThing.vTxOut[index].payLoad;
      this.payLoad_type = this.nodeThing.vTxOut[index].payLoad.type;
      this.payLoad_userData = this.nodeThing.vTxOut[index].payLoad.userData;
      this.payLoad_version = this.nodeThing.vTxOut[index].payLoad.version;
      this.dialogTableVisible = true;
    }
  }
}
</script>
<style lang="scss" scoped>
#text-boclk li span{
  width:150px;
  display: inline-block;
  color: #666;
}
.a_style{
  display: inline-block;
  width: 80px;
}
.set_style:before{
  background: #F9EA28 !important; //发起节点
  border:2px solid #F9EA28 !important;
}
.set_style2:before{
  background: #1497FC !important; //验证节点
  border:2px solid #1497FC !important;
}
.set_style3:before{
  border:2px solid #5CB85C !important;
  background: #5CB85C !important; //上链节点
}
.i_style{
  font-style: normal;
  font-size: 29px;
  color: #F9EA28;
  position: absolute;
  top: -11px;
}
.i_style2{
  font-style: normal;
  font-size: 29px;
  color: #1497FC;
  position: absolute;
  top: -11px;
}
.i_style3{
  font-style: normal;
  font-size: 29px;
  color: #5CB85C;
  position: absolute;
  top: -11px;
}
.TxOutRespond{
  color: #1385F9;
  display: inline-block;
  width: 20%;
  margin:8px 0;
  cursor: pointer;
}
.span1{
  display:inline-block;
  width:25%;
  vertical-align:top;
}
.span2{
  width:75%;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-all;
}
.text{
  ul{
    li{
      margin:8px 0;
    }
  }
}
/*纵向时间轴*/
.containerA{
  padding-left: 10%;
}
.time-vertical {
    list-style-type: none;
    border-right: 1px solid #707070;
    padding: 0px;
    width: 65%;

    // height: 400px;
}

.time-vertical li {
    height: 30px;
    position: relative;
}
.time-vertical li:last-child {
    height: 22px;
}
.time-vertical li a {
    display: inline-block;
    margin-left: 30px;
    // margin-top: 15px;
    text-decoration: none;
    color: #000;
}

.time-vertical li b:before {
    content: '';
    position: absolute;
    // top: 15px;
    right: -9px;
    width: 12px;
    height: 12px;
    border: 2px solid #98FB98;
    border-radius: 10px;
    background: #98FB98;
    top:3px;
}

.time-vertical li span {
    position: absolute;
    color: #fff;
    top: 18px;
    left: -6px;
}

.seeK{
  color:#1385F9;
  text-decoration:none;
}
.title{
padding: 10px;
}
.ul-content{
  line-height: 200px;
}
.ul-content li{
  float: left;
  width: 20%;
  text-align: center;
}
.chain_yx{
width: 85%;
margin: 0 auto;
margin-top: 20px;
background: #F1F4FF;
height: 80px;
font-size: 18px;
display: flex;
-webkit-display: flex;
justify-content: space-around;
align-items: center;
color: #4A4A4A;
p{
img{
  width: 26px;
  display: inline-block;
  vertical-align: top;
}
}
}
.title-content-a2{
margin-top: 10px !important;
height: 500px !important;
}
.content_slzs{
font-size: 14px;
padding-left: 30px;
padding-top: 10px;
color: #4A4A4A;
span{
display: inline-block;
height: 20px;
vertical-align: middle;
}
p{
width: 60%;
display: inline-block;
.content_heng1{
  background: #8635F0;
  width: 100%;
}
.content_heng2{
  width: 50%;
  background: #50CC50;
}
span{
  display: inline-block;
  height: 20px;
  vertical-align: middle;
}
.content_slzs_s{
  border-radius: 30px;
  display: inline-block;
  height: 20px;
}
}

}
#echartContainerCity,#zhuxingpaint{
width: 100%;
// min-width: 1002px;
height: 100%;
min-height: 200px;
}
.ycsj_p_div{
padding-left: 12px;
font-size: 28px;
font-weight: bold;
ul{
li{
  width: 50px;
  height: 50px;
  background: #D2DCFF;
  color: #4d74ff;
  float: left;
  margin-left: 18px;
  text-align: center;
  line-height: 50px;
}
}
}
.ycsj_p{
font-size: 18px;
padding: 30px;
color: #4A4A4A;
.rightJt{
border-radius: 50%;
-webkit-border-radius: 50%;
border: 1px solid #333;
font-size: 14px;
width: 14px;
height: 14px;
display: inline-block;
padding: 1px;
vertical-align: text-top;
margin-top: 3px;
}
}


.title-content{
display: flex;
-webkit-display: flex;
justify-content: center;
.title-content-a{
height: 200px;
box-shadow: #B7C7FF 0px 0px 20px;
margin-bottom: 15px;
.title-content-a-view{
  width: 39%;
  float: left;
}
.title-content-b-view{
  width: 60%;
  float: left;
}
}
.title-content-ab{
margin-left: 15px;
width: 70%;
min-height:800px;
overflow: auto;
background: #FFF;
}
}
</style>
